export const EMAIL_KEYS = {
  USER_ID: 'user_VWbQck254TOuY4bikGFp9',
  ACCESS_TOKEN: '35826b2f1f52d58adb2871ffdde32fd0',
  TEMPLATE_ID: 'template_6squ7xs',
  SERVICE_ID: 'service_c5d1ljq',
};
